import { QueryClient, keepPreviousData } from '@tanstack/react-query';

import { LIST_QUERY_DEFAULTS, QUERY_DEFAULTS } from '@/lib/constants';
import { ApiError } from '@/lib/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_DEFAULTS.STALE_TIME,
      gcTime: QUERY_DEFAULTS.GC_TIME,
      retry: (failureCount, error) => {
        // Don't retry 4xx — they won't change.
        //
        // Must test ApiError, NOT axios.isAxiosError: the api-client response
        // interceptor rejects with `normalizeError(error)`, so by the time a
        // query sees the failure it is always an ApiError and never an
        // AxiosError. The old axios check was dead code, which meant every 4xx
        // *was* retried — doubling the cost of each one and re-firing the
        // cadence 403's openModal side effect mid-resolution.
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < QUERY_DEFAULTS.RETRY;
      },
      // Tab-switching back to the app doesn't need to invalidate everything —
      // this is an internal clinical tool, not a public dashboard. Mutations
      // explicitly invalidate the queries they touch.
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

/** Default list-query options to apply per list hook. */
export const listQueryOptions = {
  placeholderData: keepPreviousData,
  staleTime: LIST_QUERY_DEFAULTS.STALE_TIME,
} as const;
